<div class="gardenHabitat">
  <a href="https://www.habitat-jardin.events/" target="_blank">
    <img class="habitat-image">
  </a>
</div>
